import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import DonutChart from 'components/common/chart/DonutChart';
import { TCloudChart } from 'containers/user/CloudManagementModalContainer';
import CustomSpan from 'components/common/text/CustomSpan';
import { T } from 'components/common/text';

interface CloudStorageDataProps {
  chartData: TCloudChart[];
}

const CloudStorageData = ({ chartData }: CloudStorageDataProps) => {
  const [ratio, setRatio] = useState<number>(0);
  const [usedData, setUsedData] = useState<number>(0);
  const [totalData, setTotalData] = useState<number>(0);
  const [availableData, setAvailableData] = useState<number>(0);

  useEffect(() => {
    if (!chartData) return;
    const ratio = Math.ceil((chartData[1].value / (chartData[0].value + chartData[1].value)) * 100);
    setRatio(ratio);
    const used = Math.ceil(chartData[1].value * 100) / 100;
    setUsedData(used);
    const total = Math.ceil((chartData[1].value + chartData[0].value) * 100) / 100;
    setTotalData(total);
    const available = Math.floor(chartData[0].value * 100) / 100;
    setAvailableData(available);
  }, [chartData]);
  return (
    <StyledCloudStorageData data-component-name="CloudStorageData">
      <div className="cloudStorageData__chart_box">
        <DonutChart
          data={chartData as any}
          width={190}
          bgColor="transparent"
          lineWidth={40}
          startAngle={-90 - (360 * chartData[0].value) / (chartData[0].value + chartData[1].value)}
        >
          <div className="cloudStorageData__usage">
            <CustomSpan fontSize={37}>{ratio}</CustomSpan>
            <CustomSpan fontSize={18}>{'%'}</CustomSpan>
          </div>
        </DonutChart>
        <div className="cloudStorageData__chart_value_box">
          <div className="cloudStorageData__chart_value ">
            <div className="cloudStorageData__value_label used">
              <span
                className="cloudStorageData__value_dot"
                style={{
                  backgroundColor: chartData[1].color,
                }}
              ></span>
              <CustomSpan fontSize={18} fontColor={'#888'}>
                <T>DATA_USAGE_CAPACITY</T>
              </CustomSpan>
            </div>
            <div className="cloudStorageData__value">
              <CustomSpan fontSize={24} fontColor={'#25256F'}>
                {usedData}
              </CustomSpan>{' '}
              <CustomSpan fontSize={20} fontColor={'#25256F'}>
                {`GB`}
              </CustomSpan>
            </div>
          </div>
          <div className="cloudStorageData__chart_value ">
            <div className="cloudStorageData__value_label total">
              <span
                className="cloudStorageData__value_dot"
                style={{
                  backgroundColor: chartData[0].color,
                }}
              ></span>
              <CustomSpan fontSize={18} fontColor={'#888'}>
                <T>DATA_AVAILABLE_USAGE</T>
              </CustomSpan>
            </div>
            <div className="cloudStorageData__value">
              <CustomSpan fontSize={24} fontColor={'#25256F'}>
                {availableData}
              </CustomSpan>{' '}
              <CustomSpan fontSize={20} fontColor={'#25256F'}>
                {`GB`}
              </CustomSpan>
            </div>
          </div>
        </div>
      </div>
    </StyledCloudStorageData>
  );
};

const StyledCloudStorageData = styled.div<{}>`
  width: 100%;
  .cloudStorageData__chart_box {
    padding: 44px 8px;
    position: relative;
    border-bottom: 1px solid #e1e1e7;
    display: flex;
    flex-direction: column;
    row-gap: 40px;
    .cloudStorageData__usage {
      position: absolute;
      display: flex;
      align-items: flex-end;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #25256f;
    }

    .cloudStorageData__chart_value_box {
      display: flex;
      justify-content: center;
      column-gap: 60px;
      width: 100%;
      .cloudStorageData__chart_value {
        width: 100px;
        display: flex;
        flex-direction: column;

        .cloudStorageData__value {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
        }
        .cloudStorageData__value_label {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          column-gap: 8px;
          &.used {
          }
          &.total {
          }
          .cloudStorageData__value_dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
          }
        }
      }
    }
  }
`;

export default CloudStorageData;
